import { getMinAndMaxPriceOnPropertyStatusChange } from './getMinAndMaxPriceOnPropertyStatusChange';
import { SearchPropertyStatus } from '../types';
import { getSortOptionOnPropertyStatusChange } from './getSortOptionOnPropertyStatusChange';
import { getSurroundingSuburbsOnPropertyStatusChange } from './getSurroundingSuburbsOnPropertyStatusChange';
import { hasStatusChangedFromOnMarketToOffMarket } from './hasStatusChangedFromOnMarketToOffMarket';

export const searchPropertyStatusSideEffects = ({
  minPrice,
  maxPrice,
  previousPropertyStatus,
  newPropertyStatus,
  currentSortOption,
  surroundingSuburbs,
  findSimilar,
  isGeoShapeBasedSearch = false,
}: {
  minPrice: string;
  maxPrice: string;
  previousPropertyStatus: SearchPropertyStatus;
  newPropertyStatus: SearchPropertyStatus;
  currentSortOption: string;
  surroundingSuburbs: string;
  findSimilar: { imageId: string; imageName?: string } | null;
  isGeoShapeBasedSearch?: boolean;
}): Record<string, unknown> => {
  return {
    ...getMinAndMaxPriceOnPropertyStatusChange({
      minPrice,
      maxPrice,
      previousPropertyStatus,
      newPropertyStatus,
    }),
    surroundingSuburbs: getSurroundingSuburbsOnPropertyStatusChange(
      surroundingSuburbs,
      newPropertyStatus,
    ),
    sortOption: getSortOptionOnPropertyStatusChange({
      newPropertyStatus,
      previousPropertyStatus,
      currentSortOption,
      isGeoShapeBasedSearch,
    }),
    findSimilar:
      !findSimilar ||
      hasStatusChangedFromOnMarketToOffMarket({
        previousStatus: previousPropertyStatus,
        newStatus: newPropertyStatus,
      })
        ? ''
        : `${JSON.stringify(findSimilar)}`,
  };
};
